import { log } from '../../logger'
import configProvider from '../../config'

import { apiClient } from './client'
import { MasterAccountRef } from '../../models/master-account'
import { mockMasterAccounts } from '../../mock/master-account-mock'
import { addQueryString } from 'helpers/url'

export async function GetMasterAccounts(): Promise<MasterAccountRef[]> {
  const url = '/master_accounts'

  log('fetching master accounts', { url: url })
  if (configProvider.config.mockEnabled) {
    return Promise.resolve(mockMasterAccounts)
  }
  return apiClient(url, {})
}

export async function CreateMasterAccount(name: string): Promise<MasterAccountRef> {
  const url = '/master_accounts'

  log('create a master account', { url: url })
  if (configProvider.config.mockEnabled) {
    const newMockPartner = { id: mockMasterAccounts.length + 1, name }
    return Promise.resolve(newMockPartner)
  }
  return apiClient(url, {
    method: 'POST',
    body: JSON.stringify({
      master_account: {
        name,
        remittance_frequency: 'not_applicable',
        remittance_emails_attributes: {
          emails: [],
        },
      },
    }),
  })
}

export async function UpdateMasterAccount(masterAccount: MasterAccountRef): Promise<MasterAccountRef> {
  const url = `/master_accounts/${masterAccount.id}`

  log('updating master account', { url: url })
  if (configProvider.config.mockEnabled) {
    const newMockPartner = {
      id: mockMasterAccounts.length + 1,
      name: 'mock-name',
      remittanceEmails: [],
      remittanceFrequency: 'not_applicable',
    }
    return Promise.resolve(newMockPartner)
  }
  return apiClient(url, {
    method: 'PUT',
    body: JSON.stringify({
      master_account: {
        name: masterAccount.name,
        remittance_frequency: masterAccount.remittanceFrequency,
        remittance_emails_attributes: {
          emails: masterAccount.remittanceEmails,
        },
      },
    }),
  })
}

export async function FindMasterAccount(isMockUpEnabled: boolean, term?: string): Promise<MasterAccountRef[]> {
  let url = '/master_accounts'

  let queryParams: { [key: string]: string } = {}

  if (term) {
    queryParams['term'] = `${term}`
  }

  url = addQueryString(url, queryParams)

  log('finding master account', { url })
  if (isMockUpEnabled) {
    return Promise.resolve(mockMasterAccounts)
  }
  return apiClient(url, {})
}
